import type { HandlingOperator } from '@backoffice-frontend/alerts-common'
import { FccAdAlertStatus } from '@backoffice-frontend/graphql'
import type { AdAlertFeedCardVehicleFragment } from './AdAlertFeedCard.hook'

export type CardState =
  | 'unassigned'
  | 'unassigned-hover'
  | 'assigned'
  | 'mine'
  | 'muted'

type CardStateInput = {
  handlingOperator: HandlingOperator | undefined
  currentUserId: string | undefined
  isAvailable: boolean
  isOffline: boolean
  isCurrentUserBusy: boolean
  isHovered: boolean
}

export const getCardState = ({
  handlingOperator,
  currentUserId,
  isAvailable,
  isOffline,
  isCurrentUserBusy,
  isHovered,
}: CardStateInput) => {
  const isAssignedToMe = Boolean(
    handlingOperator?.backofficeUserId &&
      currentUserId &&
      handlingOperator.backofficeUserId === currentUserId,
  )
  const isAssignedToOther = Boolean(handlingOperator) && !isAssignedToMe
  const isAssigned = isAssignedToMe || isAssignedToOther

  const cardState: CardState = (() => {
    if (isAssignedToOther) return 'assigned'
    if (isOffline) return 'muted'
    if (isAssignedToMe) return 'mine'
    if (isCurrentUserBusy) return 'muted'
    if (isHovered && isAvailable) return 'unassigned-hover'
    return 'unassigned'
  })()

  return {
    cardState,
    isAssignedToMe,
    isAssignedToOther,
    isAssigned,
    canStartHandling: isAvailable && !isAssigned && !isCurrentUserBusy,
    canTakeOverFromOther:
      isAvailable && isAssignedToOther && !isCurrentUserBusy,
  }
}

export const getActiveAlerts = (
  vehicle: Pick<AdAlertFeedCardVehicleFragment, 'roleScopedAdAlerts'>,
) =>
  vehicle.roleScopedAdAlerts?.alerts.filter(
    alert => alert.status !== FccAdAlertStatus.Closed,
  ) ?? []
